import { getDate } from '../get-date'
import { format } from 'date-fns'

export function getYearStrDateUtil (date) {
  date = getDate(date)
  return format(date, 'yyyy-M')
}
